import React from 'react';
import { FilterProps, FilterStorageKey, replacer, reviver } from '../common/filter.util';
import FilterDropdown from './FilterDropdown';

export interface BaseFilterProps {
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export abstract class BaseFilter<T> {
  className?: string;
  color?: string;
  storageKey?: FilterStorageKey;
  key: string;

  constructor(storageKey?: FilterStorageKey, key?: string) {
    this.storageKey = storageKey;
    this.key = key || '';
  }

  abstract toLabel(props: BaseFilterProps): string;
  abstract toInnerContent(props: BaseFilterProps): string | JSX.Element;
  abstract toDropdownContent(props: BaseFilterProps, open: boolean): React.JSX.Element;
  abstract toIcon(props: BaseFilterProps): React.JSX.Element;
  abstract toCount(props: BaseFilterProps): number;
  abstract search(item: T, query: string): boolean;

  filterOptions(): BaseFilter<any>[] {
    return [];
  }

  filterOptionsCount(props: BaseFilterProps): number {
    return this.filterOptions().reduce((count, filter) => count + (filter.toCount(props) ? 1 : 0), 0);
  }

  getFilterProps(): FilterProps {
    if (!this.storageKey) return new FilterProps();
    const stored = localStorage.getItem(`VENTORY_FILTER_${this.storageKey.toString()}${this.key?.toString()}`);
    if (!stored) return new FilterProps();
    return JSON.parse(stored, reviver) as FilterProps;
  }

  saveFilterProps(props: FilterProps) {
    if (!this.storageKey) return;
    return localStorage.setItem(
      `VENTORY_FILTER_${this.storageKey.toString()}${this.key?.toString()}`,
      JSON.stringify(props, replacer),
    );
  }

  toString(props: BaseFilterProps): string {
    return this.toLabel(props);
  }

  // TODO: We should implement this differently, filters should be able to user other filters when filtering items
  filteredItems(items: T[], query: string, filterProps: FilterProps): T[] {
    return items.filter(item => this.search(item, query));
  }

  toComponent(props: BaseFilterProps) {
    return (
      <>
        <p className='mb-1 text-sm text-gray-900'>{this.toLabel(props)}</p>
        <FilterDropdown
          key={this.toLabel(props)}
          icon={this.toIcon(props)}
          innerContent={this.toInnerContent(props)}
          dropdownContent={this.toDropdownContent(props, true)}
          badge={this.toCount(props)}
        />
      </>
    );
  }
}
